
const gopayIcon = require("../../images/payment/gopay/logoGopay.png");

const ovoIcon = require("../../images/payment/ewallets/logo-ovo.png");
const bniIcon = require("../../images/payment/vcount/logo-bni.png");
const briIcon = require("../../images/payment/vcount/logo-bri.png");
const mandiriIcon = require("../../images/payment/vcount/logo-mandiri.png");
const kredivoIcon = require("../../images/payment/vcount/kredivo.png");
const bcaIcon = require("../../images/payment/vcount/logo-bca.png");

const bsiIcon = require("../../images/payment/vcount/bsi.png");
const cimbIcon = require("../../images/payment/vcount/cimb.png");

const visaIcon = require("../../images/payment/visa.png");
const mastercardIcon = require("../../images/payment/mastercard.png");


const subscriptionShopee = require("../../images/payment/subscription/logo_shopeepay.png");

const flagIndonesia = require("../../images/icon_indonesia.png");
const flagSingapore = require("../../images/icon_singapore.png");
const flagThailand = require("../../images/icon_thailand.png");
const flagGlobal = require("../../images/icon_global.png");


export const getTranslate = (type, mobileLang) => {
  if (mobileLang === "id") {
    switch (type) {
      case "continue":
        return "Lanjut";
      case "continue-payment":
        return "Lanjut ke Pembayaran";
      case "select":
        return "Pilih";
      case "tncapply":
        return "S&K Berlaku";
      case "bank_transfer":
        return "Transfer Bank";
      case "retail_outlets":
        return "Toko Retail";
      case "applied":
        return "diterapkan";
      case "enter_promo_code":
        return "Masukkan kode promo";
      case "have_a_code":
        return "Punya kode?";
      case "remove_voucher":
        return "Hapus voucher";
      case "apply":
        return "Terapkan";
      case "total_payment":
        return "Total Pembayaran";
      case "choose_payment_method":
        return "Pilih Cara Pembayaran";
      case "terms_condition":
        return "Syarat & Ketentuan";
      case "subscription":
        return "BERLANGGANAN";
      case "one-time-purchase":
        return "PEMBELIAN SATU WAKTU";
      case "money-back":
        return "Jaminan 30 Hari Uang Kembali";
      case "checkout":
        return "Pembayaran";
      case "limit-reached":
        return "Melewati Batas Membership";
      case "close":
        return "Tutup";
      case "credit-card":
        return "Kartu Kredit";
      case "debit-card":
        return "Kartu Debit";
      case "terms_of_use":
        return "Syarat Penggunaan";
      case "privacy_policy":
        return "Kebijakan Privasi";
      case "payment_terms_text":
        return "Dengan melanjutkan pembayaran, kamu menyatakan telah berusia 18 tahun ke atas, serta telah membaca dan menyetujui terms_of_use serta privacy_policy kami.";
      case "yes":
        return "Ya";
      case "no":
        return "Tidak";
      case "ewallet-balance-warning":
        return "Pastikan saldo e-wallet cukup sebelum melanjutkan pembayaran.";
      case "ewallet-balance-yes":
        return "SUDAH";
      case "ewallet-balance-no":
        return "BELUM";
      // Trello 542 item 1 (owner revision 2026-09-30, card checklist "30 sep
      // 26"): when this buyer has exactly 1 counted failed web Xendit
      // checkout left before the retry limit blocks them, this full sentence
      // REPLACES the popup's normal balance-warning text outright (it is not
      // an extra line under it). Copy is verbatim from the card + reference
      // screenshot -- do not reword.
      case "ewallet-attempt-left":
        return "Tersisa 1 kesempatan. Pastikan saldo ewallet cukup sebelum melanjutkan pembayaran.";
      // Trello 546: /xt lane is IDR e-wallet only — a non-ID visitor gets an
      // empty method list, and this line is the explicit dead-end message
      // rendered instead of zero buttons.
      case "payment_method_unavailable":
        return "Metode pembayaran tidak tersedia untuk pembelian ini.";
      // Fable audit item 10: shown once when a grace-period subscriber
      // reaches checkout instead of being bounced to account-overview.
      case "grace-period-checkout-title":
        return "Masa Tenggang";
      case "grace-period-checkout-desc":
        return "Pembayaran langganan terakhirmu belum berhasil. Lanjutkan di bawah untuk membayar sekarang atau menyambungkan ulang dompetmu.";
      // Trello 651 (2 Nov 2026): info card above the method list while the backend
      // hides OVO after Xendit refused this buyer's OVO payment (Figma 471:287).
      case "ovo-technical-issue-info":
        return "OVO sedang mengalami kendala teknis. Silakan gunakan metode pembayaran lainnya.";
      default:
        return "";
    }
  } else {
    switch (type) {
      case "continue":
        return "Continue";
      case "continue-payment":
        return "Continue Payment";
      case "select":
        return "Select";
      case "tncapply":
        return "T&C Apply";
      case "bank_transfer":
        return "Bank Transfer";
      case "retail_outlets":
        return "Retail Outlets";
      case "applied":
        return "applied";
      case "enter_promo_code":
        return "Enter promo code";
      case "have_a_code":
        return "Have a code?";
      case "remove_voucher":
        return "Remove voucher";
      case "apply":
        return "Apply";
      case "total_payment":
        return "Total Payment";
      case "choose_payment_method":
        return "Choose Payment Method";
      case "terms_condition":
        return "Terms & Coditions";
      case "subscription":
        return "SUBSCRIPTION";
      case "one-time-purchase":
        return "ONE TIME PURCHASE";
      case "money-back":
        return "7 day money back guarantee";
      case "checkout":
        return "Checkout";
      case "limit-reached":
        return "Limit Reached";
      case "close":
        return "Close";
      case "credit-card":
        return "Credit Card";
      case "debit-card":
        return "Debit Card";
      case "terms_of_use":
        return "Terms of Use";
      case "privacy_policy":
        return "Privacy Policy";
      case "payment_terms_text":
        return "By proceeding with the payment, you confirm that you are 18 years of age or older and that you have read and agreed to our terms_of_use and privacy_policy.";
      case "yes":
        return "Yes";
      case "no":
        return "No";
      case "ewallet-balance-warning":
        return "Please make sure your e-wallet has enough balance before payment.";
      case "ewallet-balance-yes":
        return "DONE";
      case "ewallet-balance-no":
        return "NOT YET";
      case "ewallet-attempt-left":
        return "1 attempt left. Please make sure your e-wallet has enough balance before payment.";
      case "payment_method_unavailable":
        return "This payment method is not available for this purchase.";
      case "grace-period-checkout-title":
        return "Grace Period";
      case "grace-period-checkout-desc":
        return "Your last subscription payment did not go through. Continue below to pay now or reconnect your wallet.";
      case "ovo-technical-issue-info":
        return "OVO is currently experiencing technical issues. Please use other payment method.";
      default:
        return "";
    }
  }
};

export const getListPaymentONETime = (mobileLang) => [
  {
    title: "GoPay",
    method: [gopayIcon],
    key: "GOPAY",
  },
  {
    title: "E-Wallet",
    method: [ovoIcon, subscriptionShopee],
    key: "EWALLET",
  },
  {
    title: getTranslate("bank_transfer", mobileLang),
    method: [bcaIcon, mandiriIcon, bniIcon, briIcon, bsiIcon, cimbIcon],
    key: "VIRTUAL_ACCOUNT",
  },
  {
    title: "Kredivo",
    method: [kredivoIcon],
    key: "KREDIVO",
  },
];
// OVO on the subscription checkout. It was hidden (false) from 1 to 2 Nov 2026
// while Xendit refused every OVO charge with 403 INVALID_MERCHANT_SETTINGS
// (31 Oct 2026 06:23 WIB onwards). Turned back on once a fresh OVO link and
// older member links passed Xendit's merchant check again. If OVO breaks
// again, set this to false and hold the channel in the payment engine
// (ORCH_CHARGE_HOLD_CHANNELS=OVO) so a buyer never links a wallet that
// cannot be charged.
export const XENDIT_OVO_SUBSCRIPTION_ENABLED = true;

export const getListSubcriptionPaymentAlt = (mobileLang, country_code) => {
  const normalizedCountryCode = (country_code || "ID").toUpperCase();
  switch (normalizedCountryCode) {
    case "ID":
      return [
        // GoPay stays hidden: Xendit has not enabled GoPay on the production
        // account, and the backend (SubscriptionCheckout::
        // normalizePaymentSourceByCountry) would route a GOPAY pick into the
        // Xendit CARD lane — the buyer would land on a card form.
        // {
        //   title: "GoPay",
        //   method: [gopayIcon],
        //   key: "GOPAY_RECURRING",
        // },
        // Owner 2 Nov 2026: ShopeePay listed above OVO.
        {
          title: "ShopeePay",
          method: [subscriptionShopee],
          key: "XENDIT-SHOPEEPAY",
        },
        ...(XENDIT_OVO_SUBSCRIPTION_ENABLED
          ? [
            {
              title: "OVO",
              method: [ovoIcon],
              key: "XENDIT-OVO",
            },
          ]
          : []),
        // Credit card hidden for now (owner 2026-09-30): ID subscriptions are
        // e-wallet only until the owner re-enables the Xendit card lane. The
        // backend XENDIT-CARD lane and the card-linked result state stay in
        // place so un-commenting this row is the whole switch back.
        // {
        //   title: getTranslate("credit-card", mobileLang),
        //   method: [mastercardIcon, visaIcon],
        //   key: "XENDIT-CARD",
        // },
        // Trello 467 (XENDIT OKTOBER 1 MITIGATION): debit card stays hidden.
        // {
        //   title: getTranslate("debit-card", mobileLang),
        //   method: [bcaIcon, mandiriIcon, bniIcon, briIcon, bsiIcon, cimbIcon],
        //   key: "XENDIT-CARD",
        // },
      ];
    default:
      // Foreign customers go through Cleeng — only one card option is needed
      // (Trello WEB card 8 May 26 follow-up).
      return [
        {
          title: "Credit Card",
          method: [mastercardIcon, visaIcon],
          key: "cleeng",
        },
      ];
  }
};


export const listCountryPayment = [
  {
    title: "Global (USD)",
    source: flagGlobal,
    key: "worldwide",
  },
  {
    title: "Indonesia (IDR)",
    source: flagIndonesia,
    key: "ID",
  },
  {
    title: "Singapore",
    source: flagSingapore,
    key: "SG",
  },
  {
    title: "Thailand (THB)",
    source: flagThailand,
    key: "TH",
  }
];

const defaultCountryPayment = listCountryPayment[0];

export const getCountryPaymentDetail = (code) => {
  if (!code || typeof code !== "string") {
    return defaultCountryPayment;
  }
  const key = code.toLocaleLowerCase();
  const found = listCountryPayment.find((item) => (item.key || "").toLocaleLowerCase() === key);
  return (found && found.source) ? found : defaultCountryPayment;
};
